/**
 * 新疆舆情管理路由
 * 2017-12-24
 */
"use strict";
angular.module("publicOpinionMgrZjRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.
    state("front.planningresource.commandMonitor.publicopinionmgrzj", {
        url: "/publicopinionmgrzj",
        views: {
            "main@front.planningresource.commandMonitor": {
                templateUrl: "./planningResource/commandMonitor/publicOpinionMgrZj/publicOpinionMgrZj_tpl.html",                
                controller: "publicOpinionMgrZjCtrl"
            }
        }
    }).    
    state("front.planningresource.commandMonitor.publicopinionmgrzj.functionlist", {  //新疆舆情功能列表
        url: "/functionlist",
        views: {
            "main@front.planningresource.commandMonitor.publicopinionmgrzj": {
                templateUrl: "./planningResource/commandMonitor/publicOpinionMgrZj/functionList/functionList_tpl.html",                            
                controller: "functionListCtrl"
            },
            'nav@front.planningresource.commandMonitor.publicopinionmgrzj': {
                templateUrl: './planningResource/commandMonitor/publicOpinionMgrZj/publicOpinionMgrZjNav_tpl.html',                            
                controller: 'publicOpininonMgrZjNavctrl',
            }
        }
    }).
    state("front.planningresource.commandMonitor.publicopinionmgrzj.displaysetting", {  //新疆舆情显示设置
        url: "/displaySetting",
        views: {
            "main@front.planningresource.commandMonitor.publicopinionmgrzj": {
                templateUrl: "./planningResource/commandMonitor/publicOpinionMgrZj/displaySetting/displaySetting_tpl.html",
                controller: "displaySettingCtrl"
            },
            'nav@front.planningresource.commandMonitor.publicopinionmgrzj': {
                templateUrl: './planningResource/commandMonitor/publicOpinionMgrZj/publicOpinionMgrZjNav_tpl.html',
                controller: 'publicOpininonMgrZjNavctrl',
            }
        }
    }).
    state("front.planningresource.commandMonitor.publicopinionmgrzj.newtopicrule", {  //新疆舆情最新话题规则
        url: "/newTopicRule",
        views: {
            "main@front.planningresource.commandMonitor.publicopinionmgrzj": {
                templateUrl: "./planningResource/commandMonitor/publicOpinionMgrZj/newTopicRule/newTopicRule_tpl.html",
                controller: "newTopicRuleCtrl"
            },
            'nav@front.planningresource.commandMonitor.publicopinionmgrzj': {
                templateUrl: './planningResource/commandMonitor/publicOpinionMgrZj/publicOpinionMgrZjNav_tpl.html',
                controller: 'publicOpininonMgrZjNavctrl',
            }
        }
    }).
    state("front.planningresource.commandMonitor.publicopinionmgrzj.burstnewsrule", {  //新疆舆情最新话题规则
        url: "/burstNewsRule",
        views: {
            "main@front.planningresource.commandMonitor.publicopinionmgrzj": {
                templateUrl: "./planningResource/commandMonitor/publicOpinionMgrZj/burstNewsRule/burstNewsRule_tpl.html",
                controller: "burstNewsRuleCtrl"
            },
            'nav@front.planningresource.commandMonitor.publicopinionmgrzj': {
                templateUrl: './planningResource/commandMonitor/publicOpinionMgrZj/publicOpinionMgrZjNav_tpl.html',
                controller: 'publicOpininonMgrZjNavctrl',
            }
        }
    }).
    state("front.planningresource.commandMonitor.publicopinionmgrzj.historyhotadmin", {  //新疆舆情最新话题规则
        url: "/historyHotAdmin",
        views: {
            "main@front.planningresource.commandMonitor.publicopinionmgrzj": {
                templateUrl: "./planningResource/commandMonitor/publicOpinionMgrZj/historyHotAdmin/historyHotAdmin_tpl.html",
                controller: "historyHotAdminCtrl"
            },
            'nav@front.planningresource.commandMonitor.publicopinionmgrzj': {
                templateUrl: './planningResource/commandMonitor/publicOpinionMgrZj/publicOpinionMgrZjNav_tpl.html',
                controller: 'publicOpininonMgrZjNavctrl',
            }
        }
    });
}]);